import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '../lib/auth';
import { useEffect } from 'react';
import { useQuery as useConvexQuery } from 'convex/react';
import { api } from '../../../../convex/_generated/api';
import { RecipeEditForm } from '../components/RecipeEditForm';

export const Route = createFileRoute('/recipes/$recipeId/edit')({
  component: RecipeEditPage,
});

function RecipeEditPage() {
  const { recipeId } = Route.useParams();
  const { isSignedIn, isLoaded } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      navigate({ to: '/' });
    }
  }, [isLoaded, isSignedIn, navigate]);
  
  const recipe = useConvexQuery(api.recipes.getById, { id: recipeId as any });
  const isLoading = recipe === undefined;
  
  const handleCancel = () => {
    navigate({ to: '/recipes/$recipeId', params: { recipeId } });
  };
  
  const handleSaved = () => {
    navigate({ to: '/recipes/$recipeId', params: { recipeId } });
  };
  
  if (!isLoaded || isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="text-stone">Loading...</div>
      </div>
    );
  }
  
  if (!recipe) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-ink mb-4">Recipe Not Found</h1>
          <button onClick={() => navigate({ to: '/recipes' })} className="text-coral-600 hover:underline">
            ← Back to Recipes
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="font-display text-2xl font-semibold text-ink mb-6">Edit Recipe</h1>
      <RecipeEditForm 
        recipe={recipe as any} 
        onCancel={handleCancel}
        onSaved={handleSaved}
      />
    </div>
  );
}
